import styles from './machine.module.scss';
import { CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

/* eslint-disable-next-line */
export interface MachineProps {
  loan?: ILoan
}

export function Machine(props: MachineProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.computerInfo?.userName || ''}
            fullWidth
            label={t("standard.user")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.computerInfo?.domain || ''}
            fullWidth
            label={t("standard.domain")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.computerInfo?.computerName || ''}
            fullWidth
            label={t("standard.machine")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.computerInfo?.volumeId || ''}
            fullWidth
            label={t("standard.volumeID")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.computerInfo?.diskId || ''}
            fullWidth
            label={t("machine.diskID")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.computerInfo?.operatingSystem || ''}
            fullWidth
            label={t("standard.operatingSystem")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <label>{t("standard.macAddresses")}:</label>
          {props.loan?.computerInfo?.macAddresses.map(address =>
            <TextField
              value={address || ''}
              fullWidth
              disabled
              key={address}
              className='mb-3'
            />
          )}
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.virtualMachine")}
            checked={props.loan?.computerInfo?.isVirtualMachine}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Machine;